import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function FeelingSection({ emoji, title, description, color, index }) {
  const sectionRef = useRef();
  const visualRef = useRef();
  const contentRef = useRef();

  useEffect(() => {
    const section = sectionRef.current;
    const visual = visualRef.current;
    const content = contentRef.current;

    // Parallax effect on visual
    gsap.to(visual, {
      y: -100,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1
      }
    });

    // Fade in content
    gsap.fromTo(
      content,
      { opacity: 0, x: index % 2 === 0 ? -100 : 100 },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        scrollTrigger: {
          trigger: section,
          start: 'top 70%',
          end: 'top 30%',
          toggleActions: 'play none none reverse'
        }
      }
    );

    // Scale emoji on scroll
    gsap.fromTo(
      visual.querySelector('.feeling-emoji'),
      { scale: 0.8, rotation: -10 },
      {
        scale: 1,
        rotation: 0,
        duration: 1,
        scrollTrigger: {
          trigger: section,
          start: 'top 70%',
          end: 'top 30%',
          toggleActions: 'play none none reverse'
        }
      }
    );
  }, [index]);

  return (
    <section 
      ref={sectionRef} 
      className="feeling-section" 
      style={{ background: color }}
    >
      <div className="feeling-container">
        <div ref={visualRef} className="feeling-visual">
          <div className="feeling-emoji">{emoji}</div>
        </div>
        
        <div ref={contentRef} className="feeling-content">
          <div className="feeling-number">0{index + 1}</div>
          <h2 className="feeling-title">{title}</h2>
          <p className="feeling-description">{description}</p>
        </div>
      </div>
    </section>
  );
}

export default FeelingSection;